<template>
    <div class="col-12">
        <div class="row">
            <div class="col-md-6 text-left" v-for="checkbox in this.privacyCheckboxes">
                <mcw-checkbox @change="onPrivacyCheck(checkbox)" :checked="privacy_obj[checkbox.db_name] === 1">
                    {{checkbox.label}}
                    <a v-if="!!checkbox.url" href="#" class="a3" @click.prevent="openPrivacyModal(checkbox)">
                        <i>{{$t('news.leggi')}} »</i>
                    </a>
                </mcw-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IncPrivacyCheckboxes",
    inject: {
        privacyModalProvider: {
            from: 'openPrivacyModal',
            default: null
        }
    },
    props: ['privacyCheckboxes', 'userInfo'],
    data() {
        return {
            privacy_obj: this.getprivacyObj()
        }
    },
    methods: {
        getprivacyObj: function () {
            const obj = {};
            this.privacyCheckboxes.forEach((privacyCheckbox) => {
                obj[privacyCheckbox.db_name] = false;
            });
            if (this.userInfo && this.userInfo.privacy) obj.privacy = this.userInfo.privacy;

            return obj;
        },
        onPrivacyCheck: function (checkbox) {
            this.privacy_obj = Object.assign({}, this.privacy_obj, {
                [checkbox.db_name]:
                    this.privacy_obj[checkbox.db_name] === 1 ? 0 : 1,
            });

            this.$emit('onPrivacyChange', this.privacy_obj);
        },
        openPrivacyModal: function (checkbox) {
            if (this.privacyModalProvider) {
                this.privacyModalProvider(checkbox);
            }
        },
    }
}
</script>
